export const currencyDecimalParser = n => Number.parseFloat(n).toFixed(2);

export function abbrNum(value) {
  const suffixes = ['', 'K', 'M', 'B', 'T'];
  let newValue = value;
  let suffixNum = 0;
  // value > 1000 need add suffix
  while (newValue >= 1000) {
    newValue /= 1000;
    suffixNum++;
  }

  newValue = Math.floor(newValue * 10) / 10;

  return `${newValue}${suffixes[suffixNum]}`;
}



// WEBPACK FOOTER //
// ./app/utils/decimalParser.js